export const CalendlyUrls = {
  en: {
    nutrition:
      'https://calendly.com/geneplanet/en-consultation-diet-and-nutrition',
    consultations:
      'https://calendly.com/geneplanet/en-consultations-general-wellbeing',
    sports:
      'https://calendly.com/geneplanet/en-consultations-sport-and-recreation',
  },
  sl: {
    nutrition:
      'https://calendly.com/geneplanet/sl-consultation-diet-and-nutrition',
    consultations:
      'https://calendly.com/geneplanet/sl-consultations-general-wellbeing',
    sports:
      'https://calendly.com/geneplanet/sl-consultations-sport-and-recreation',
  },
  pl: {
    nutrition:
      'https://calendly.com/geneplanet/pl-consultation-diet-and-nutrition',
    consultations:
      'https://calendly.com/geneplanet/pl-consultations-general-wellbeing',
    sports:
      'https://calendly.com/geneplanet/pl-consultations-sport-and-recreation',
  },
  sk: {
    nutrition:
      'https://calendly.com/geneplanet/svk-consultation-diet-and-nutrition',
    consultations:
      'https://calendly.com/geneplanet/svk-consultations-general-wellbeing',
    sports:
      'https://calendly.com/geneplanet/svk-consultations-sport-and-recreation',
  },
};
